import React from "react";
import Layout from "../components/Layout";
import { ReporteCallCenter as Reporte } from "../components/ReporteCallCenter/ReporteCallCenter";

const ReporteCallCenter = () => {
  return (
    <>
      <Layout />
      <div>
        <Reporte />
      </div>
    </>
  );
};

export default ReporteCallCenter;
